import { render, staticRenderFns } from "./multiLineTextStyle.vue?vue&type=template&id=8f10a554&scoped=true"
import script from "./multiLineTextStyle.vue?vue&type=script&lang=js"
export * from "./multiLineTextStyle.vue?vue&type=script&lang=js"
import style0 from "./multiLineTextStyle.vue?vue&type=style&index=0&id=8f10a554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f10a554",
  null
  
)

export default component.exports